"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerStringToUSLocaleString = void 0;
/**
 * Change the non-locale integer string to locale string.
 * Only support en-US format.
 * This method uses the BigInt if the environment supports the BigInt.
 * @param numberStr
 */
function integerStringToUSLocaleString(numberStr) {
    if (numberStr.indexOf(".") >= 0) {
        throw new Error(`${numberStr} is not integer`);
    }
    if (typeof BigInt !== "undefined") {
        return BigInt(numberStr).toLocaleString("en-US");
    }
    const integer = numberStr;
    const chunks = [];
    for (let i = integer.length; i > 0; i -= 3) {
        chunks.push(integer.slice(Math.max(0, i - 3), i));
    }
    return chunks.reverse().join(",");
}
exports.integerStringToUSLocaleString = integerStringToUSLocaleString;
//# sourceMappingURL=utils.js.map